import React, { useMemo, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import block from 'bem-cn';
import SVGInline from 'react-svg-inline';

import useIfInviteHidden from 'modules/App/model/useInvitePlayer/useIfInviteHidden';

import { checkBonusPromoAllowed } from 'features/bonusProgram/data';

import arrowSvg from './img/arrow.svg';

import './ListItem.scss';

const b = block('list-item');

const ListItem = ({ item, changeMenuOpen, isParent = true }) => {
  const location = useLocation();

  const [isOpened, setOpened] = useState(item.children?.length ? true : null);

  const authData = useSelector(s => s.auth);
  const locale = useSelector(state => state.locale.locale);
  const semiAutoWithdrawalEnabled = useSelector(state => state.auth.semiAutoWithdrawalEnabled);
  const isCashbackActive = useSelector(state => state.auth.isCashbackActive);
  const ifInviteHidden = useIfInviteHidden();

  if (item.title === 'bonusProgram' && !checkBonusPromoAllowed(authData)) {
    return null;
  }

  if (item.title === 'playerDeposits' && !semiAutoWithdrawalEnabled) {
    return null;
  }

  if (item.title === 'referralPlayers' && ifInviteHidden) {
    return null;
  }

  if (item.checkForActiveCashback && !isCashbackActive) {
    return null;
  }

  const onClick = useCallback(() => {
    if (item?.children) {
      if (isOpened === null) {
        setOpened(true);
      } else {
        setOpened(prevState => !prevState);
      }
    }

    if (!isParent) changeMenuOpen(false);
  }, [isOpened, item, changeMenuOpen, isParent]);

  const childrens = useMemo(
    () =>
      item.children?.map(el => (
        <ListItem item={el} key={el.title} isParent={false} changeMenuOpen={changeMenuOpen} />
      )) || [],
    [item, changeMenuOpen],
  );

  const isActive = item.withStartsWith ? location.pathname.startsWith(item.routeForActiveTab) : location.pathname === item.routeForActiveTab;

  return (
    <div className={b({ active: isActive })}>
      <Link to={item.route} className={b('parent', { level: item.level })} onClick={onClick}>
        <div className={b('parent', 'td')}>
          {item.img && item.whiteImg && (
            <SVGInline svg={isActive ? item.whiteImg : item.img} className={b('parent', 'img-icon').toString()} />
          )}
          <span className={b('parent', 'title')}>{locale[item.title] || item.title}</span>
        </div>

        {item?.children && (
          <SVGInline svg={arrowSvg} className={b('parent', 'img-arrow', { opened: isOpened }).toString()} />
        )}
        {Boolean(item.count) && <span className={b('parent', 'count')}>{item.count <= 99 ? item.count : '99+'}</span>}
      </Link>
      {isOpened && <div className={b('children')}>{childrens}</div>}
    </div>
  );
};

export default ListItem;
